import { c as _c } from "react/compiler-runtime";
import { AvailabilityEnum, EventEnum } from "@sprawdzonabron/shared";
import { useEffect, useRef } from "react";
import { useAnalyticsEvent } from "../../api/hooks/useAnalyticsEvent";
import { ChecklistCardEnum } from "./types";
export const getAvailabilityText = (available: AvailabilityEnum): string => {
  switch (available) {
    case AvailabilityEnum.Yes:
      return "Dostępny";
    case AvailabilityEnum.No:
      return "Niedostępny";
    case AvailabilityEnum.Unknown:
      return "Brak danych o dostępności";
    default:
      return "Brak danych o dostępności";
  }
};
export const getSummaryText = (productsCount: number, shopsCount: number): string => {
  switch (productsCount) {
    case 0:
      return "Brak produktów spełniających kryteria wyszukiwania.";
    case 1:
      return `Znaleziono 1 produkt`;
    case 2:
    case 3:
    case 4:
      return `Znaleziono ${productsCount} produkty w ${shopsCount} sklepach`;
    case 10000:
      return `Znaleziono ponad 10000 produktów w ${shopsCount} sklepach`;
    default:
      return `Znaleziono ${productsCount} produktów w ${shopsCount} ${shopsCount === 1 ? "sklepie" : "sklepach"}`;
  }
};
export const useChecklistAnalytics = variant => {
  const $ = _c(7);
  const postCtaVisibleEvent = useAnalyticsEvent(EventEnum.NewsletterChecklistCTADVisible);
  const postCtaClickEvent = useAnalyticsEvent(EventEnum.NewsletterChecklistCTAClick);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] !== postCtaVisibleEvent || $[1] !== variant) {
    t0 = () => {
      if (!ref.current) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          const storageKey = `${EventEnum.NewsletterChecklistCTADVisible}-${variant}`;
          const alreadySent = sessionStorage.getItem(storageKey);
          if (!alreadySent) {
            postCtaVisibleEvent(variant);
            sessionStorage.setItem(storageKey, "true");
          }
          observer.disconnect();
        }
      }, {
        threshold: 0.5
      });
      observer.observe(ref.current);
      return () => observer.disconnect();
    };
    t1 = [postCtaVisibleEvent, variant];
    $[0] = postCtaVisibleEvent;
    $[1] = variant;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== postCtaClickEvent || $[5] !== variant) {
    const onLinkClick = () => {
      postCtaClickEvent(variant);
    };
    t2 = {
      ref,
      onLinkClick
    };
    $[4] = postCtaClickEvent;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};